import {protectedAxiosInstance} from "./AxiosInstance";
import {del, post} from "./request";

export const chatApi = {};

chatApi.createRoom = async ({clientId, offerId, technicianId}) => {
  try {
    const response = await post(`/chatroom/add`, {
      clientId,
      offerId,
      technicianId,
    });
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};
chatApi.deleteRoom = async ({id}) => {
  try {
    const response = await del(`/chatroom/${id}`);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

chatApi.getAll = async ({filter}) => {
  try {
    const {data} = await post(`/chatroom/all`, {filter: filter}, {size: 999});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

chatApi.getOne = async ({roomID}) => {
  try {
    const {data} = await post(`/chatroom/one/${roomID}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

chatApi.deleteMessage = async ({messageId}) => {
  try {
    const {data} = await del(`/chatmessage/${messageId}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

chatApi.sendAttachment = async ({roomId, text, file}) => {
  const formData = new FormData();
  formData.append("roomId", String(roomId));
  formData.append("text", text || "");
  formData.append("attachment", file, file.name);
  const response = await protectedAxiosInstance.post(
    "/api/chatmessage/attachment",
    formData,
  );
  return response.data;
};
